import { Link } from "react-router-dom";

const CeritaUMKM = () => {
  // const [apiData, setApiData] = useState([]);

  // useEffect(() =>{
  //   axios.get(`https://62e74e8269bd03090f7b19cb.mockapi.io/TrUmkmTestimony`)
  //   .then((getData) => {
  //     setApiData(getData.data);
  //   });
  // });

  return (
    <section className="testimony-container">
      <p className="homePage-title">Cerita UMKM</p>
      <p className="testimony-textBelowTitle">
        Apa yang UMKM katakan setelah belajar di Relation Apps
      </p>
      <div className="testimony-row">
        <div className="testimony-card">
          <div className="testimony-column">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Corrupti, facilis error. Soluta, unde, officiis laborum ipsam
              molestias possimus eum numquam aperiam exercitationem repudiandae
              harum atque, laboriosam reprehenderit odit illo asperiores neque
              dignissimos nesciunt consequuntur sequi beatae nisi. Ratione, quis
              accusantium!
            </p>
            <p className="testimony-readMore">Read more</p>
          </div>
          <p className="testimony-name">Kenny Melvern</p>
        </div>
        <div className="testimony-card">
          <div className="testimony-column">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Corrupti, facilis error. Soluta, unde, officiis laborum ipsam
              molestias possimus eum numquam aperiam exercitationem repudiandae
              harum atque, laboriosam reprehenderit odit illo asperiores neque
              dignissimos nesciunt consequuntur sequi beatae nisi. Ratione, quis
              accusantium!
            </p>
            <p className="testimony-readMore">Read more</p>
          </div>
          <p className="testimony-name">Matthew Thomas</p>
        </div>
        <div className="testimony-card">
          <div className="testimony-column">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Corrupti, facilis error. Soluta, unde, officiis laborum ipsam
              molestias possimus eum numquam aperiam exercitationem repudiandae
              harum atque, laboriosam reprehenderit odit illo asperiores neque
              dignissimos nesciunt consequuntur sequi beatae nisi. Ratione, quis
              accusantium!
            </p>
            <p className="testimony-readMore">Read more</p>
          </div>
          <p className="testimony-name">Rayhan Fahlevy</p>
        </div>
      </div>
      <div className="testimony-footer">
        <Link to="/CeritaUMKM">
          <button className="viewAllButton">View All</button>
        </Link>
      </div>
    </section>
  );
};

export default CeritaUMKM;
